import _ from "lodash";
import React, { useEffect } from "react";

import { withRouter } from "react-router";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Button from "common/components/CustomButtons/Button.jsx";
import Card from "common/components/Card/Card.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";

import loadContent from "core-module/hoc/loadContent";
import PackageSpeedDisplay from "./PackageSpeedDisplay.jsx";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import pricingPageStyle from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  stats: importedStyle.stats,
  cardIconTitle: importedStyle.cardIconTitle,
  cardDescription: {
    display: "flex",
    flexDirection: "column",
  },
  marginTop30: {
    marginTop: "30px",
  },
  ...pricingPageStyle,
  packageContainer: {
    alignSelf: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "15px",
    padding: "10px",
  },
  PROclass: {
    backgroundColor: "azure",
  },
};

const Emoji = (props) => (
  <span
    className="emoji"
    role="img"
    aria-label={props.label ? props.label : ""}
    aria-hidden={props.label ? "false" : "true"}
  >
    {props.symbol}
  </span>
);

const UpgradeOptions = (props) => {
  const { classes } = props;

  const locationState = props.location.state;
  const onSelectUpgradePackage = props.onSelectUpgradePackage;

  useEffect(() => {
    if (
      locationState != null &&
      "action" in locationState &&
      locationState.action === "upgrade"
    ) {
      const packageList = props.getList(
        (oGet, id) => [oGet, id],
        () => null,
        (ids, getDataWithId) => {
          //This parameter is a modifier function to sort ids by Cap
          const unsortedCollection = [];
          for (let id of ids) {
            unsortedCollection.push({
              id,
              cap: getDataWithId("cap", id, "value"),
            });
          }
          const sortedCollection = _.sortBy(unsortedCollection, ["cap"]);
          const sortedIds = [];
          for (let myObject of sortedCollection) {
            sortedIds.push(myObject.id);
          }
          return sortedIds;
        }
      );
      if (packageList != null) {
        const nextPackage = packageList[0];
        onSelectUpgradePackage(nextPackage[1], {
          description: nextPackage[0]("description"),
          cap: nextPackage[0]("cap"),
          monthly_fee: nextPackage[0]("monthly_fee"),
          rate_download: nextPackage[0]("rate_download"),
          rate_upload: nextPackage[0]("rate_upload"),
          parked: nextPackage[0]("parked", "value"),
          no_access: nextPackage[0]("no_access", "value"),
          advertised_download_mbps: nextPackage[0](
            "advertised_download_mbps",
            "value"
          ),
          advertised_upload_mbps: nextPackage[0](
            "advertised_upload_mbps",
            "value"
          ),
        });
      }
    }
  });

  return (
    <div className={classes.container}>
      <GridContainer>
        {props.getList(
          (oGet, id) => {
            let description = oGet("description");
            if (oGet("link")) {
              description = description.replace("(see website for terms)", "");
            }
            return (
              <GridItem key={id} xs={12} sm={6} md={6} lg={4}>
                <Card pricing className={id === 65 ? classes.PROclass : null}>
                  <CardBody pricing className={classes.packageContainer}>
                    <div>
                      {id === 65 ? (
                        <div key="stars">
                          <Emoji symbol="🌟" label="Glowing Star" />
                          <Emoji symbol="🌟" label="Glowing Star" />
                          <Emoji symbol="🌟" label="Glowing Star" />
                        </div>
                      ) : null}

                      <h6 className={classes.cardCategory}>
                        {description}{" "}
                        {oGet("link") ? (
                          <a href={oGet("link")}>(see website for terms)</a>
                        ) : null}
                      </h6>

                      {/^9+$/.test(oGet("cap")) ? (
                        <h3>
                          Unlimited <br /> Data
                          <br />
                        </h3>
                      ) : (
                        <h3>
                          {oGet("cap")}
                          <small> GB</small>
                          {props.extraLoyaltyGb > 0 ? (
                            <small key="addedExtraLoyalty">
                              <br />
                              (+ your {props.extraLoyaltyGb} loyalty GB)
                            </small>
                          ) : null}
                        </h3>
                      )}
                      <PackageSpeedDisplay
                        packageInfo={{
                          cap: oGet("cap"),
                          rate_download: oGet("rate_download"),
                          rate_upload: oGet("rate_upload"),
                          parked: oGet("parked", "value"),
                          no_access: oGet("no_access", "value"),
                          advertised_download_mbps: oGet(
                            "advertised_download_mbps",
                            "value"
                          ),
                          advertised_upload_mbps: oGet(
                            "advertised_upload_mbps",
                            "value"
                          ),
                        }}
                        className={classes.cardDescription}
                      />
                      <h3
                        className={`${classes.cardTitle} ${classes.marginTop30}`}
                      >
                        $ {oGet("monthly_fee")} / month
                        {props.currentFee != null ? (
                          <small key="extraMoneyText">
                            <br />
                            (an extra ${" "}
                            {(oGet("monthly_fee") - props.currentFee).toFixed(
                              2
                            )}{" "}
                            / month)
                          </small>
                        ) : null}
                      </h3>
                      <br />
                      <Button
                        color="primaryRed"
                        onClick={() =>
                          props.onSelectUpgradePackage(id, {
                            description: oGet("description"),
                            cap: oGet("cap"),
                            monthly_fee: oGet("monthly_fee"),
                            rate_download: oGet("rate_download"),
                            rate_upload: oGet("rate_upload"),
                            parked: oGet("parked", "value"),
                            no_access: oGet("no_access", "value"),
                            advertised_download_mbps: oGet(
                              "advertised_download_mbps",
                              "value"
                            ),
                            advertised_upload_mbps: oGet(
                              "advertised_upload_mbps",
                              "value"
                            ),
                          })
                        }
                      >
                        SELECT
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </GridItem>
            );
          },
          () => (
            <GridItem xs={12}>
              <Card>
                <CardBody className={classes.packageContainer}>
                  <p className={classes.cardDescription}>
                    Please contact our office to make changes to your plan.
                    <br />
                    Toll Free Number: 1-866-390-3928
                    <br />
                    Email: support@mcsnet.ca
                    <br />
                    Address: 4810 50th Ave, PO Box 98, St Paul, AB T0A3A0
                  </p>
                </CardBody>
              </Card>
            </GridItem>
          ),
          (ids, getDataWithId) => {
            //This parameter is a modifier function to sort ids by Cap
            const unsortedCollection = [];
            for (let id of ids) {
              unsortedCollection.push({
                id,
                cap: getDataWithId("cap", id, "value"),
              });
            }
            const sortedCollection = _.sortBy(unsortedCollection, ["cap"]);
            const sortedIds = [];
            for (let myObject of sortedCollection) {
              sortedIds.push(myObject.id);
            }
            return sortedIds;
          }
        )}
      </GridContainer>
    </div>
  );
};

export default withStyles(styles)(
  withRouter(loadContent("user.session/upgradable", UpgradeOptions))
);
